let resumeData = {
    "imagebaseurl":"https://TusharSharma16.github.io/",
    "name": "Tushar Sharma",
    "role": "Data Scientist",
    "linkedinId":"https://www.linkedin.com/in/tusharsharma16/",
    "skypeid": "Your skypeid",
    "roleDescription": "I like dabbling in various parts of Agile Development Procedures and like to learn about new technologies, write technical articles or simply play games in my free time.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/tusharsharma16/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/TusharSharma16/",
          "className":"fa fa-github"
        }
      ],
    "aboutme":"I am currently a final year student pursuing B.E. from Sir M.Visveswaraya Institute of Technology. I am a self taught student and currently diving deeper into Machine Learning and Data Analytics. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
    "address":"India",
    "website":"https://TusharSharma16.github.io",
    "education":[
      {
        "UniversityName":"Sir M.Visveswaraya Insitute of Technology, Bangalore",
        "specialization":"Computer Science and Engineering",
        "MonthOfPassing":"Aug",
        "YearOfPassing":"2020",
        "Achievements":"Current SGPA: 8.1"
      },
      {
        "UniversityName":"Delhi Public School, Gandhidham",
        "specialization":"Secondary and Senior Secondary Degree",
        "MonthOfPassing":"Jun",
        "YearOfPassing":"2016",
        "Achievements":"Secondary CGPA:9, Senior Secondary CGPA:8.5"
      }
    ],
    "work":[
      {
        "CompanyName":"EIP-3.0, Phase-1, NASSCOM and Inkers.ai",
        "specialization":"Deep Learning Intern",
        "MonthOfLeaving":"April",
        "YearOfLeaving":"2019",
        "Achievements":"Implementation of ResNet-50 model on Tiny-ImageNet with 43% Accuracy"
      },
      {
        "CompanyName":"EIP-3.0, Phase-2, NASSCOM and Inkers.ai",
        "specialization":"Deep Learning Intern",
        "MonthOfLeaving":"Aug",
        "YearOfLeaving":"2019",
        "Achievements":"Succesfully Finished with Advance Concepts in CNN"
      }
    ],
    "skillsDescription":"Skills:",
    "skills":[
      {
        "skillname":"C"
      },
      {
        "skillname":"Java"
      },
      {
        "skillname":"DBMS"
      },
      {
        "skillname":"Python"
      },
      {
        "skillname":"R"
      },
      {
        "skillname":"Linux"
      }
    ],
    "portfolio":[
      {
        "name":"Personalized Image Styler using OpenGL and OpenCV",
        "description":"Platform: 'Linux' Technologies Used: 'OpenGL', 'OpenCV', 'Python 3'. An interactive platform to style images made using OpenGL and OpenCV implementations. This project was part of the Computer Graphics Lab Mini Project",
        "imgurl":"images/portfolio/project.jpeg"
      },
      {
        "name":"Insuruptor (FinTech Project)",
        "description":"Platform: 'Multiplatform Web-app'. Technologies Used: 'HTML', 'CSS', 'MySQL', 'Python 3', 'Flask'. Insuruptor is an integrated data analytics platform that solves multiple sets of problems associated with the insurance industry to ensure the maximization of growth with optimal profits. URL: ​ https://github.com/TusharSharma16/Acko-Insurance-Hack",
        "imgurl":"images/portfolio/project.jpeg"
      },
      {
        "name":"Tsukuyomi (Movie Recommender System)",
        "description":"Platform: 'Multiplatform Web-app'. Technologies used: 'HTML', 'CSS', 'MySQL', 'Python 3', 'Flask'. A movie recommendation engine based Database Management System built as an open-source movie recommender to promote freedom of software. Tsukuyomi is a dynamically designed Database with input features of Artificial Intelligence and Machine Learning which transforms it from a static database into a self-enhancing database where users can access movie ratings, submit new ratings and it would learn their preferences providing them with relevant recommendations. URL: ​ https://github.com/TusharSharma16/Tsukuyomi",
        "imgurl":"images/portfolio/project.jpeg"
      },
      {
        "name":"ResNet 50 Implementation on Tiny ImageNet Dataset",
        "description":"Platform: 'Google Colaboratory' / 'Jupyter Notebook'. Technologies used: 'Python 3'. Tiny ImageNet classification challenge is similar to the classification challenge in the full ImageNet ILSVRC. Tiny ImageNet contains 200 classes for training. Each class has 500 images. The test set contains 10,000 images. All images are 64x64 colored ones. The objective was to classify the 10,000 test set images as accurately as possible. The Architecture follows trained on 64x64 from beginning to end with 16+16=32 then adding one cosine clr policy of 32 epochs then adding Augmentation to the images to 16 epochs, afterward with smooth labeling till 32 epochs. The final Validation Accuracy achieved is 64.20%. URL:​ https://github.com/TusharSharma16/EIP-3.0/blob/master/WEEK%204/EIP3_A4.ipynb",
        "imgurl":"images/portfolio/project.jpeg"
      },
      {
        "name":"Ignatious-Phoenix (Wildfire Detection and Reporter)",
        "description":"Platform: 'Multiplatform Web-app'. Technologies used: 'HTML', 'CSS', 'MySQL', 'Python 3', 'Flask'. The Project analyzes the data on the previous dataset for early detection, verification, Tracking, Visualization of Wildfires with live weather updates and location generator from IP Address and Validates the fire based on Computer Vision Algorithms. URL: ​ https://github.com/TusharSharma16/Ignatious-Phoenix",
        "imgurl":"images/portfolio/project.jpeg"
      },
      {
        "name":"Facial Recognition using OpenCV",
        "description":"Platform: 'Multiplatform Web-app'. Technologies used: 'Python 3'. Uses haar cascades to recognize facial features, patterns and performs feature extraction followed by labeling the data to recognize the faces on a live webcam. URL: https://github.com/TusharSharma16/Facial-Recognition-using-OpenCV",
        "imgurl":"images/portfolio/project.jpeg"
      }
    ],
    "publications":[
      {
        "description":"Forecasting Dengue and Studying Plausible Pandemy using Machine Learning. Paper Link: http://www.ijrat.org/downloads/Vol-7/junes-2019/76S201910",
        "name":"International Journal of Research in Advent Technology (IJRAT)"
      },
      {
        "description":"Tuberculosis Patient Adherence System using Deep Learning and Computer Vision",
        "name":"INTERNATIONAL CONFERENCE ON RECENT TRENDS ON ELECTRONICS, INFORMATION & COMMUNICATION TECHNOLOGY (under IEEE Publication)"
      },
      {
        "description":"Machine Learning to Predict the contribution of the closeness factor in AODV Routing protocol for social networks",
        "name":"Currently Writing"
      }
    ]
  }

  export default resumeData
